(() => {
  const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const get = name => root.querySelector('[data-guide-' + name + ']');
    const search = get('search'), brand = get('brand'), count = get('count'), empty = get('empty');
    const server = get('server-pagination'), loading = get('loading'), client = get('client-pagination');
    if (!search || !brand || !server) return;
    let cards = [...root.querySelectorAll('[data-guide-card]')];
    const seen = new Set(cards.map(c => c.querySelector('a').getAttribute('href')));
    const visited = new Set();
    const appendPage = doc => {
      const section = doc.querySelector('[data-guide-library]');
      if (!section) throw new Error('Missing guide library');
      section.querySelectorAll('[data-guide-card]').forEach(card => {
        const href = card.querySelector('a').getAttribute('href');
        if (!seen.has(href)) { seen.add(href); root.querySelector('.sg-grid').append(card); }
      });
      return section.querySelector('[data-guide-server-pagination]')?.dataset.nextUrl || '';
    };
    try {
      let next = Number(server.dataset.currentPage) > 1 ? server.dataset.firstUrl : server.dataset.nextUrl;
      if (next) { loading.hidden = false; loading.textContent = 'Chargement de tous les guides pour la recherche…'; }
      while (next) {
        const url = new URL(next, window.location.href);
        if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Guide loading failed');
        next = appendPage(new DOMParser().parseFromString(await response.text(), 'text/html'));
      }
      if (!root.isConnected) return;
      cards = [...root.querySelectorAll('[data-guide-card]')];
      cards.sort((a,b) => a.dataset.search.localeCompare(b.dataset.search, 'fr', {numeric:true}));
      cards.forEach(c => root.querySelector('.sg-grid').append(c));
      [...new Set(cards.map(c => c.dataset.brand).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'fr')).forEach(name => {
        const option = document.createElement('option'); option.value = name; option.textContent = name; brand.append(option);
      });
      let page = 1;
      const pageSize = 24;
      function render() {
        const terms = norm(search.value).split(/\s+/).filter(Boolean);
        const matches = cards.filter(c => (!brand.value || brand.value === c.dataset.brand) && terms.every(t => norm(c.dataset.search).includes(t)));
        const pages = Math.max(1, Math.ceil(matches.length / pageSize)); page = Math.min(page, pages);
        const visible = new Set(matches.slice((page-1)*pageSize, page*pageSize));
        cards.forEach(c => c.hidden = !visible.has(c));
        count.textContent = matches.length + ' guide' + (matches.length === 1 ? '' : 's') + (matches.length !== cards.length ? ' sur ' + cards.length : '');
        empty.hidden = matches.length > 0;
        client.hidden = pages <= 1;
        get('page').textContent = 'Page ' + page + ' sur ' + pages;
        get('previous').disabled = page === 1; get('next').disabled = page === pages;
      }
      const filter = () => { page = 1; render(); };
      search.addEventListener('input',filter); brand.addEventListener('change',filter);
      get('reset').addEventListener('click',()=>{ search.value='';brand.value='';filter();search.focus(); });
      get('previous').addEventListener('click',()=>{ page--;render();root.querySelector('.sg-result-heading').scrollIntoView({block:'start'}); });
      get('next').addEventListener('click',()=>{ page++;render();root.querySelector('.sg-result-heading').scrollIntoView({block:'start'}); });
      server.hidden = true; loading.hidden = true; get('filters').hidden = false; render();
    } catch (error) {
      loading.hidden = false;
      loading.textContent = 'La recherche globale est momentanément indisponible. Parcourez les guides avec les liens de pagination ci-dessous.';
      server.hidden = false;
    }
  }
  document.querySelectorAll('[data-guide-library]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-guide-library]').forEach(init));
})();